export function megaMenuUpd() {
    let linksContainer = $(".header .top-links").find("a");
    let $megaMenu;
    let $th;
    let $body = $("body");
    let $win = $("window");

    let newLinks = "";

    for (let i = 0; i < linksContainer.length; i++) {
        newLinks += (`<a href="
                        `+ $(linksContainer[i]).attr("href") +`">`+ $(linksContainer[i]).text() +
                    `</a>`);
    }

    let copyNav = `<li class="header-nav-copy mega-menu-item">
                    ` + newLinks +`
                    </li>`;

    $(document).on("click", ".dashicons-arrow-down-alt2, .search-btn-mob", function () {
        $megaMenu = $(".max-mega-menu");
        $th = $(this);

        $megaMenu.toggleClass("open-item");

        if ($th.hasClass("search-btn-mob")) {
            $megaMenu.toggleClass("open-search");

            $th.parent().toggleClass("mega-toggle-on");

            if ($th.parent().hasClass("mega-toggle-on")) {
                if (!$megaMenu.hasClass("open-item")) {
                    $megaMenu.addClass("open-item");
                }

                $th.parent()
                    .siblings(".mega-toggle-on")
                    .removeClass("mega-toggle-on");
            }
        }
    });

    $(document).on("click", "#mega-toggle-block-2", function () {

        if (!$("#mega-menu-menu-1").hasClass("add-nav")) {
            $("#mega-menu-menu-1").append(copyNav).addClass("add-nav");

            $(".mega-menu-item-34511").append("<button class='mega-menu-link search-btn-mob'>Search</button>").addClass("mega-parent search-holder");
        }

        setTimeout(function() {
            if (!$body.hasClass("white-header")) {
                $(".mega-menu-wrap").removeClass("active");
            }
        }, 30);
    });

    $win.on("load", function() {
        let $widget = $("body").find(".axeptio_mount");

        if ($widget.length && $win.width() < 1200) {
            $("#mega-menu-menu-1").addClass("page-has-vigets");
            $(".center-bottom-mobile").addClass("page-has-vigets");
        }
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/megaMenuUpd.js